import { Body, Box, Heading } from '@hover/blueprint';
import type { IconProp } from '@hover/icons/dist/declarations/src';
import React, { useContext, useEffect } from 'react';

import { LoginAnotherWay } from 'src/modules/onboarding/components/LoginAnotherWay';
import { OnboardingContext } from 'src/modules/onboarding/components/OnboardingContext';
import { ButtonLink } from 'src/shared/components/Link';
import { TranslationNamespace, useTranslate } from 'src/shared/hooks';
import { buttonPressed, pageViewed } from 'src/shared/telemetry';

import { Component as GmailIcon } from 'assets/img/logos/google.svg';
import { Component as OutlookIcon } from 'assets/img/logos/outlook.svg';

export const CheckEmail = () => {
  const t = useTranslate(TranslationNamespace.SHARED);
  const [state] = useContext(OnboardingContext);
  const { email } = state;

  useEffect(() => {
    pageViewed({
      page_or_screen_name: 'Onboarding-email-input-verification',
      feature: 'onboarding',
    });
  }, []);

  return (
    <Box
      alignItems="center"
      flexDirection="column"
      height="100vh"
      justifyContent="center"
      m={500}
    >
      <Box alignItems="center" flexDirection="column" justifyContent="center">
        <Heading
          color="neutral700"
          fontWeight="headingLight"
          size={{ base: 700, tablet: 900 }}
        >
          {t('onboarding.checkYourEmail')}
        </Heading>
        <Body as="span" color="neutral.500" marginBottom={700}>
          {t('onboarding.weSentAnEmail')}
          <Body as="span" color="neutral.700">
            {email}
          </Body>
          {t('onboarding.toConfirmThatIts')}
        </Body>
        <ButtonLink
          aria-label={t('onboarding.openGmail')}
          fill="outline"
          height={500}
          iconBefore={GmailIcon as IconProp}
          isExternal
          marginBottom={300}
          onClick={() =>
            buttonPressed({
              button_text: 'Open Gmail',
              page_or_screen_name: 'Login-email_check',
              feature: 'onboarding',
            })
          }
          p={400}
          textDecoration="none"
          to="https://mail.google.com"
          variant="tertiary"
          width={{ base: '100%', tablet: '80%' }}
        >
          <Body fontWeight={600} m={0}>
            {t('onboarding.openGmail')}
          </Body>
        </ButtonLink>
        <ButtonLink
          aria-label={t('onboarding.openOutlook')}
          fill="outline"
          height={500}
          iconBefore={OutlookIcon as IconProp}
          isExternal
          onClick={() =>
            buttonPressed({
              button_text: 'Open Outlook',
              page_or_screen_name: 'Login-email_check',
              feature: 'onboarding',
            })
          }
          p={400}
          textDecoration="none"
          to="https://outlook.office.com/mail/inbox"
          width={{ base: '100%', tablet: '80%' }}
        >
          <Body fontWeight={600} m={0}>
            {t('onboarding.openOutlook')}
          </Body>
        </ButtonLink>
      </Box>
      <LoginAnotherWay pageOrScreenName="Login-email_check" />
    </Box>
  );
};
